/* if ($('body').hasClass('home') == true) {
  $('.navbar .sub-navbar-mobile').show();
  $(".navbar-desktop ul.navbar-nav li.nav-item").each(function() {
    var href = $('a', this).attr("href");
    if (href !== '/productos') {
      href = href.split('/')[1];
      $('a', this).attr("href", "#content-" + href);
    }
  });
  $(".navbar .sub-navbar-mobile .nav-item .nav-link").each(function() {
    var href = $(this).attr("href");
    if (href !== '/productos') {
      href = href.split('/')[1];
      $(this).attr("href", "#content-" + href);
    }
  });

} else {
  $('.navbar .sub-navbar-mobile').hide();
}*/
new WOW().init();

$('.button-collapse').sideNav({
    menuWidth: 300, // Default is 240
    edge: 'left', // Choose the horizontal origin
    closeOnClick: true, // Closes side-nav on <a> clicks, useful for Angular/Meteor
    draggable: true
});

$('.mdb-select').material_select();
/*$('.datepicker').pickadate({
  weekdaysFull: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  monthsFull: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Semptiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
  today: 'Hoy',
  clear: 'Limpiar',
  formatSubmit: 'yyyy/mm/dd',
  close: 'Cerrar',
  max: true
});*/

if (lang.indexOf("es-") > -1) {
    $('.datepicker').pickadate({
        weekdaysFull: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        monthsFull: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
        today: 'Hoy',
        clear: 'Limpiar',
        formatSubmit: 'yyyy/mm/dd',
        close: 'Cerrar',
        max: true
    });
}
else if (lang.indexOf("pt-") > -1) {
    $('.datepicker').pickadate({
        weekdaysFull: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
        monthsFull: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        today: 'Hoje',
        clear: 'Claro',
        formatSubmit: 'yyyy/mm/dd',
        close: 'Fechar',
        max: true
    });
}
else if (lang.indexOf("en-") > -1) {
    $('.datepicker').pickadate({
        weekdaysFull: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        monthsFull: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        today: 'Today',
        clear: 'Clear',
        formatSubmit: 'yyyy/mm/dd',
        close: 'Close',
        max: true
    });
}

var $table = $('.table-vacunas');
var $fixedColumn = $table.clone().insertBefore($table).addClass('fixed-column');

$fixedColumn.find('th:not(:first-child),td:not(:first-child)').remove();

$fixedColumn.find('tr').each(function(i, elem) {
    $(this).height($table.find('tr:eq(' + i + ')').height());
});

/*$(".navbar-toggle").on("click", function(e) {
 $(this).toggleClass("open");
 $("body").toggleClass("menu-active");
 $(".navbar-collapse").toggleClass("in");
 setTimeout(function() {
 $(".navbar-nav li, .wrapper-social").toggleClass("active");
 }, 100);
 e.preventDefault();
 });*/


/*var bodyClasses = ($('body').attr('class') || '').split(' ');

 for (var i = 0, len = bodyClasses.length; i < len; i++) {
 switch (bodyClasses[i]) {
 case 'embarazo-parto':
 $(".nav-embarazo").addClass('active');
 break;
 case 'bebes-cero-uno':
 $(".nav-0a1").addClass('active');
 break;
 case 'bebes-uno-tres':
 $(".nav-1a3").addClass('active');
 break;
 case 'recien-nacidos':
 $(".nav-neo").addClass('active');
 break;
 case 'padres-hoy':
 $(".nav-padres-hoy").addClass('active');
 break;
 case 'dejando-los-panales':
 $(".nav-dejando-los-panales").addClass('active');
 break;
 case 'productos':
 $(".nav-productos").addClass('active');
 break;
 default:
 $(".nav-link").removeClass('active');
 }
 }*/


/*******************************************************************************
 SCROLL TO
 *******************************************************************************/
$('.nav-item a[href*=#]:not([href=#])').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top - 120
            }, 800);
            return false;
        }
    }
});


/*******************************************************************************
 SVG TO HTML
 *******************************************************************************/
jQuery('img.svg').each(function() {
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgAlt = $img.attr('alt');
    var imgURL = $img.attr('src');

    jQuery.get(imgURL, function(data) {
        var $svg = jQuery(data).find('svg');
        if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
        }
        if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
            $svg = $svg.attr('alt', imgAlt);
        }
        $svg = $svg.removeAttr('xmlns:a');
        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
            $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }
        $img.replaceWith($svg);
    }, 'xml');
});


/*******************************************************************************
 Search
 *******************************************************************************/
$(".form_search").removeClass("waves-effect waves-light");

$("#search").focus(function(e) {
    $(".form_search").css("zIndex", 99);
    e.preventDefault();
});

$('#search').focus(function() {
    $(".navbar-brand, .rotate-device").addClass("active");
}).blur(function() {
    $(".navbar-brand").removeClass("active");
    setTimeout(function() {
        $(".rotate-device").removeClass("active");
    }, 1000);
});


/*******************************************************************************
 FIX HEADER TOP
 *******************************************************************************/
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= 10) {
        $(".header").addClass("fixTop");
        //console.log(scroll);
    }
    else {
        $(".header").removeClass("fixTop");
    }
});

/*******************************************************************************
 Hide Header on on scroll down
 *******************************************************************************/

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.header').outerHeight();
var navbarHeight = 30;

$(window).scroll(function(event) {
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 180);

function hasScrolled() {
    var st = $(this).scrollTop();
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta)
        return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $('.header').removeClass('nav-down').addClass('nav-up');
    }
    else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
            $('.header').removeClass('nav-up').addClass('nav-down');
        }
    }

    lastScrollTop = st;
}


/*******************************************************************************
 HERO PRINCIPAL
 *******************************************************************************/

function getDomainOnly(url) {
    var justDomain = url;
    justDomain = justDomain.replace('http://', '');
    justDomain = justDomain.replace('https://', '');
    if (justDomain.indexOf('/') > 0) {
        justDomain = justDomain.substr(0, justDomain.indexOf('/'));
    }
    return justDomain;
}
var els = document.getElementsByTagName('a');
[].forEach.call(els, function(eachItem) {
    if (typeof eachItem.href !== 'undefined') {
        if (getDomainOnly(eachItem.href) !== getDomainOnly(window.location.href))
            eachItem.target = '_blank';
    }
});
// SLIDER SINGLE
$(".slider-multimedia .swiper-container").each(function(index, element) {
    var $this = $(this);
    if ($(".slide.hero .slider-multimedia .swiper-container .swiper-wrapper .swiper-slide").length == 1) {
        $('.swiper-pagination').addClass("disabled");
    }
    $this.attr('id', "slider-multimedia-" + index);
    $this.find(".swiper-button-prev").addClass("btn-prev-multimedia-" + index);
    $this.find(".swiper-button-next").addClass("btn-next-multimedia-" + index);
    $this.find(".swiper-pagination").addClass("swiper-pagination-multimedia-" + index);

    var swiperMultimedia = new Swiper("#slider-multimedia-" + index, {
        paginationClickable: true,
        preventClicks: false,
        //keyboardControl: true,
        resistanceRatio: 0,
        preventClicksPropagation: false,
        speed: 1600,
        slideClass: 'swiper-slide:not(.hero)',
        parallax: true,
        grabCursor: true,
        loop: false,
        pagination: ".swiper-pagination-multimedia-" + index,
        nextButton: ".btn-next-multimedia-" + index,
        prevButton: ".btn-prev-multimedia-" + index
    });
    
    var swiperHero = new Swiper(".hero #slider-multimedia-" + index, {
        paginationClickable: true,
        preventClicks: false,
        //keyboardControl: true,
        resistanceRatio: 0,
        preventClicksPropagation: false,
        speed: 1600,
        autoplay: 4500,
        parallax: true,
        grabCursor: true,
        loop: false,
        pagination: ".swiper-pagination-multimedia-" + index,
        nextButton: ".btn-next-multimedia-" + index,
        prevButton: ".btn-prev-multimedia-" + index
    });
});

// SLIDER DOBLE

$(".slider-multimedia-doble .swiper-container").each(function(index, element) {
    var $this = $(this);
    $this.attr('id', "slider-multimedia-doble" + index);
    $this.find(".swiper-button-prev").addClass("btn-prev-multimedia-doble" + index);
    $this.find(".swiper-button-next").addClass("btn-next-multimedia-doble" + index);
    $this.find(".swiper-pagination").addClass("swiper-pagination-multimedia-doble" + index);
    var swiperMultimedia = new Swiper("#slider-multimedia-doble" + index, {
        paginationClickable: true,
        preventClicks: false,
        //keyboardControl: true,
        resistanceRatio: 0,
        preventClicksPropagation: false,
        speed: 1600,
        autoplay: 4500,
        parallax: true,
        grabCursor: true,
        loop: true,
        pagination: ".swiper-pagination-multimedia-doble" + index,
        nextButton: ".btn-next-multimedia-doble" + index,
        prevButton: ".btn-prev-multimedia-doble" + index
    });
});


/*******************************************************************************
 SWIPER PRODUCTS
 *******************************************************************************/

// var numImage = $('.swiper-slide').length;
// if (numImage == 1) {
//   $('.swiper-pagination').hide();
//   $('.swiper-button-prev').hide();
//   $('.swiper-button-next').hide();
// } else {
//   $('.swiper-pagination').show();
//   $('.swiper-button-prev').show();
//   $('.swiper-button-next').show();
// }


var galleryTopProduct = new Swiper('.gallery-top', {
    spaceBetween: 10,
    zoom: true,
    pagination: '.swiper-pagination-gallery-product',
    zoomMax: 1.5,
    onSlideChangeEnd: function(swiper) {
        var activeIndex = swiper.activeIndex;
        $(galleryThumbsProduct.slides).removeClass('is-selected');
        $(galleryThumbsProduct.slides).eq(activeIndex).addClass('is-selected');
        galleryThumbsProduct.slideTo(activeIndex, 150, false);
        console.log("bbbb");
    }
});
var galleryThumbsProduct = new Swiper('.gallery-thumbs', {
    spaceBetween: 10,
    freeMode: true,
    centeredSlides: false,
    slidesPerView: 'auto',
    touchRatio: 0.2,

    //direction: 'vertical',
    onClick: function(swiper, event) {
        console.log("aaaaaa");
        var clicked = swiper.clickedIndex;
        swiper.activeIndex = clicked; //don't need this
        swiper.updateClasses(); //don't need this
        $(swiper.slides).removeClass('is-selected');
        $(swiper.clickedSlide).addClass('is-selected');
        galleryTopProduct.slideTo(clicked, 150, false);

    }
});


var ProductTamDisp = new Swiper('.tamanos-disponibles', {
    slidesPerView: 5,
    paginationClickable: false,
    spaceBetween: 5,
    grabCursor: true,
    freeMode: true,
    preventClicks: false,
    resistanceRatio: 0,
    preventClicksPropagation: false,
    breakpoints: {
        640: {
            slidesPerView: 3
        }
    }
});


/*******************************************************************************
 CAMBIO DE IMG EN HERO
 *******************************************************************************/
$(function() {
    if (matchMedia) {
        var mq = window.matchMedia("(min-width: 993px)");
        mq.addListener(WidthChange);
        WidthChange(mq);
    }

    function WidthChange(mq) {
        if (mq.matches) {
            $(".bg_images_dm").each(function() {
                var attr = $(this).attr('data-image-src');
                if (typeof attr !== typeof undefined && attr !== false) {
                    $(this).css('background-image', 'url(' + attr + ')');
                }
            });
        }
        else {
            $(".bg_images_dm").each(function() {
                var attr = $(this).attr('data-image-src-sm');
                if (typeof attr !== typeof undefined && attr !== false) {
                    $(this).css('background-image', 'url(' + attr + ')');
                }
            });
        }
    }
});



/*******************************************************************************
 TITLE PARALLAX
 *******************************************************************************/
$(window).scroll(function() {
    var scrollLenght = $(window).scrollTop();
    if (scrollLenght >= 0) {
        $('.parallax-mt, .hero .data').css('margin-top', 0 + (scrollLenght / 4));
    };
    //console.log(scrollLenght);
});


/*******************************************************************************
 ISOTOPE VROOM
 *******************************************************************************/

$('.item-filter select').on('change', function() {
    buttonFilter = this.value;
    $('html,body').animate({
            scrollTop: $("#filters").offset().top - 75
        },
        'slow');
    $grid.isotope();
    load_images();
});

// var qsRegex;
// var buttonFilter;
var $grid = $('.grid-vroom').isotope({
    itemSelector: '.ls-card-item',
    layoutMode: 'fitRows',
    // filter: function() {
    //     var $this = $(this);
    //     var searchResult = qsRegex ? $this.text().match(qsRegex) : true;
    //     var buttonResult = buttonFilter ? $this.is(buttonFilter) : true;
    //     return searchResult && buttonResult;
    // },
});

// $grid.on('layoutComplete', function(event, laidOutItems) {
//     $(window).trigger("scroll");
// });

// $('#filters').on('click', 'button', function() {
//     buttonFilter = $(this).attr('data-filter');
//     $grid.isotope();
// });

// $('#content-menu-filter ul li .item').on('click', function() {
//     buttonFilter = $(this).attr('data-filter');
//     $grid.isotope();
// });

// $('#content-menu-filter h4 a.prods').on('click', function() {
//     buttonFilter = $(this).attr('data-filter');
//     $grid.isotope();
// });

// var $quicksearch = $('.quicksearch').keyup(debounce(function() {
//     qsRegex = new RegExp($quicksearch.val(), 'gi');
//     $grid.isotope();
// }));


// $('.item-filter').each(function(i, buttonGroup) {
//     var $buttonGroup = $(buttonGroup);
//     $buttonGroup.on('click', 'button', function() {
//         $buttonGroup.find('.active').removeClass('active');
//         $(this).addClass('active');
//     });
// });


// function debounce(fn, threshold) {
//     var timeout;
//     return function debounced() {
//         if (timeout) {
//             clearTimeout(timeout);
//         }

//         function delayed() {
//             fn();
//             timeout = null;
//         }

//         setTimeout(delayed, threshold || 50);
//     };
// }

$('.card-list .ls-card-question .card-center').on('click', function(e) {
    $(this).parent().parent().toggleClass("active");
    e.preventDefault();
});

$('.card-list .ls-card-question .close').on('click', function(e) {
    $(this).parent().parent().parent().toggleClass("active");
    e.preventDefault();
});


// var load_images = function() {
//     $('.lazy').lazy({
//         threshold: 0,
//         visibleOnly: true,
//         beforeLoad: function(element) {
//             $(element).addClass('lazy-loading')
//         },
//         afterLoad: function(element) {
//             $(element).removeClass('lazy-loading')
//             $(element).addClass('animated fadeIn')
//         }
//     })
// }
// load_images();



/*******************************************************************************
 Slider range Embarazo y Parto
 *******************************************************************************/
/*var $re = $('#rangeEmbarazo');
var $rulerEmbarazo = $('<ul id="rulerEmbarazo" class="rangeslider__ruler"> />');

// Initialize
$re.rangeslider({
  polyfill: false,
  onInit: function() {
    $rulerEmbarazo[0].innerHTML = getRulerRangeEmbarazo(this.min, this.max, this.step);
    this.$range.prepend($rulerEmbarazo);
  },
  // Callback function
  onSlide: function(position, value) {
    $(".title.meses span").html(value);
    $('#rulerEmbarazo li').removeClass("active");
    $('#rulerEmbarazo li:nth-child(' + value + ')').addClass("active");
  }
  // onSlideEnd: function(position, value) {
  //   console.log(value);
  // }

});

function getRulerRangeEmbarazo(min, max, step) {
  var range = '';
  var i = 1;

  while (i <= max) {
    range += '<li class="pin-size">' + i + '</li>';
    i = i + step;
  }
  return range;

}

function changeTextRuleEmbarazo() {
  var inicio = '<p><strong>Inicio</strong></p>',
    primero = '<p><strong>1º</strong> Trimestre</p>',
    segundo = '<p><strong>2º</strong> Trimestre</p>',
    tercero = '<p><strong>3º</strong> Trimestre</p>',
    parto = '<p><strong>Parto</strong><br></p>';

  $("#rulerEmbarazo li:nth-child(1)").html(inicio).addClass("active");
  $("#rulerEmbarazo li:nth-child(2)").html(primero);
  $("#rulerEmbarazo li:nth-child(3)").html(segundo);
  $("#rulerEmbarazo li:nth-child(4)").html(tercero);
  $("#rulerEmbarazo li:nth-child(5)").html(parto);
}

changeTextRuleEmbarazo();*/


/*******************************************************************************
 Slider range 0 a 1 años
 *******************************************************************************/
/*var $re = $('#rangeBebesCeroUno');
 var $rulerBebesCeroUno = $('<ul id="rulerBebesCeroUno" class="rangeslider__ruler"> />');

 // Initialize
 $re.rangeslider({
 polyfill: false,
 onInit: function() {
 $rulerBebesCeroUno[0].innerHTML = getRulerRangeBebesCeroUno(this.min, this.max, this.step);
 this.$range.prepend($rulerBebesCeroUno);
 },
 // Callback function
 onSlide: function(position, value) {
 $(".title.meses span").html(value);
 $('#rulerBebesCeroUno li').removeClass("active");
 $('#rulerBebesCeroUno li:nth-child(' + value + ')').addClass("active");
 }
 // onSlideEnd: function(position, value) {
 //   console.log(value);
 // }

 });

 function getRulerRangeBebesCeroUno(min, max, step) {
 var range = '';
 var i = 1;

 while (i <= max) {
 range += '<li class="pin-size">' + i + '</li>';
 i = i + step;
 }
 return range;

 }

 function changeTextRuleBebesCeroUno() {
 var primero = '<p><strong>1º</strong> Trimestre</p>',
 segundo = '<p><strong>2º</strong> Trimestre</p>',
 tercero = '<p><strong>3º</strong> Trimestre</p>',
 cuarto = '<p><strong>4º</strong> Trimestre</p>';

 $("#rulerBebesCeroUno li:nth-child(1)").html(primero).addClass("active");
 $("#rulerBebesCeroUno li:nth-child(2)").html(segundo);
 $("#rulerBebesCeroUno li:nth-child(3)").html(tercero);
 $("#rulerBebesCeroUno li:nth-child(4)").html(cuarto);
 }

 changeTextRuleBebesCeroUno();*/


/*******************************************************************************
 Slider range 1 a 3 años
 *******************************************************************************/
/*var $re = $('#rangeBebesUnoTres');
 var $rulerBebesUnoTres = $('<ul id="rulerBebesUnoTres" class="rangeslider__ruler"> />');

 // Initialize
 $re.rangeslider({
 polyfill: false,
 onInit: function() {
 $rulerBebesUnoTres[0].innerHTML = getRulerRangeBebesUnoTres(this.min, this.max, this.step);
 this.$range.prepend($rulerBebesUnoTres);
 },
 // Callback function
 onSlide: function(position, value) {
 $(".title.meses span").html(value);
 $('#rulerBebesUnoTres li').removeClass("active");
 $('#rulerBebesUnoTres li:nth-child(' + value + ')').addClass("active");
 }
 // onSlideEnd: function(position, value) {
 //   console.log(value);
 // }

 });

 function getRulerRangeBebesUnoTres(min, max, step) {
 var range = '';
 var i = 1;

 while (i <= max) {
 range += '<li class="pin-size">' + i + '</li>';
 i = i + step;
 }
 return range;

 }

 function changeTextRuleBebesUnoTres() {
 var primero = '<p><strong>1º</strong> Semestre</p>',
 segundo = '<p><strong>2º</strong> Semestre</p>',
 tercero = '<p><strong>3º</strong> Semestre</p>',
 cuarto = '<p><strong>4º</strong> Semestre</p>',
 quinto = '<p><strong>5º</strong> Semestre</p>',
 sexto = '<p><strong>6º</strong> Semestre</p>';

 $("#rulerBebesUnoTres li:nth-child(1)").html(primero).addClass("active");
 $("#rulerBebesUnoTres li:nth-child(2)").html(segundo);
 $("#rulerBebesUnoTres li:nth-child(3)").html(tercero);
 $("#rulerBebesUnoTres li:nth-child(4)").html(cuarto);
 $("#rulerBebesUnoTres li:nth-child(5)").html(quinto);
 $("#rulerBebesUnoTres li:nth-child(6)").html(sexto);
 }

 changeTextRuleBebesUnoTres();*/

/*******************************************************************************
 Slider range Recien Nacidos
 *******************************************************************************/
/*var $re = $('#rangeRecienNacidos');
 var $rulerRecienNacidos = $('<ul id="rulerRecienNacidos" class="rangeslider__ruler"> />');

 // Initialize
 $re.rangeslider({
 polyfill: false,
 onInit: function() {
 $rulerRecienNacidos[0].innerHTML = getRulerRangeRecienNacidos(this.min, this.max, this.step);
 this.$range.prepend($rulerRecienNacidos);
 },
 // Callback function
 onSlide: function(position, value) {
 $(".title.meses span").html(value);
 $('#rulerRecienNacidos li').removeClass("active");
 $('#rulerRecienNacidos li:nth-child(' + value + ')').addClass("active");
 }
 // onSlideEnd: function(position, value) {
 //   console.log(value);
 // }

 });

 function getRulerRangeRecienNacidos(min, max, step) {
 var range = '';
 var i = 1;

 while (i <= max) {
 range += '<li class="pin-size">' + i + '</li>';
 i = i + step;
 }
 return range;

 }

 function changeTextRuleRecienNacidos() {
 var inicio = '<p><strong>1ª</strong> Semana</p>',
 primera = '<p><strong>2ª</strong> Semana</p>',
 segunda = '<p><strong>3ª</strong> Semana</p>',
 tercera = '<p><strong>4ª</strong> Semana</p>',
 cuarta = '<p><strong>5ª</strong> Semana</p>',
 quinta = '<p><strong>6ª</strong> Semana</p>',
 sexta = '<p><strong>7ª</strong> Semana</p>';

 $("#rulerRecienNacidos li:nth-child(1)").html(inicio).addClass("active");
 $("#rulerRecienNacidos li:nth-child(2)").html(primera);
 $("#rulerRecienNacidos li:nth-child(3)").html(segunda);
 $("#rulerRecienNacidos li:nth-child(4)").html(tercera);
 $("#rulerRecienNacidos li:nth-child(5)").html(cuarta);
 $("#rulerRecienNacidos li:nth-child(6)").html(quinta);
 $("#rulerRecienNacidos li:nth-child(7)").html(sexta);
 }

 changeTextRuleRecienNacidos();*/


/*******************************************************************************
 Slider range Producto
 *******************************************************************************/
/*var $rp = $('#rangeProducto');
 var $rulerProductos = $('<ul id="rulerProducts" class="rangeslider__ruler"> />');

 // Initialize
 $rp.rangeslider({
 polyfill: false,
 onInit: function() {
 $rulerProductos[0].innerHTML = getRulerRangeProducto(this.min, this.max, this.step);
 this.$range.prepend($rulerProductos);
 },
 // Callback function
 onSlide: function(position, value) {
 $('#rulerProducts li').removeClass("active");
 $('#rulerProducts li:nth-child(' + value + ')').addClass("active");
 }
 // onSlideEnd: function(position, value) {
 //   console.log(value);
 // }

 });

 function getRulerRangeProducto(min, max, step) {
 var range = '';
 var i = 1;

 while (i <= max) {
 range += '<li class="pin-size">' + i + '</li>';
 i = i + step;
 }
 return range;

 }

 function changeTextRule() {
 var sizeTodos = '<p><strong>Todos</strong></p>',
 sizeRN = '<p><strong>RN</strong><br>Recién Nacido<br>Hasta 4.5 Kg</p>',
 sizeP = '<p><strong>P</strong><br>Chico<br>Hasta 6 Kg</p>',
 sizeM = '<p><strong>M</strong><br>Mediano<br>De 5 a 9.5 Kg</p>',
 sizeG = '<p><strong>G</strong><br>Grande<br>De 8.5 a 12 Kg</p>',
 sizeXG = '<p><strong>XG</strong><br>Extra Grande<br>De 11 a 14 Kg</p>',
 sizeXXG = '<p><strong>XXG</strong><br>Extra Extra Grande<br>Más de 13 Kg</p>',
 sizeDejar = '<p><strong>Dejar los Pañales</strong>';

 $("#rulerProducts li:nth-child(1)").html(sizeTodos).addClass("active");
 $("#rulerProducts li:nth-child(2)").html(sizeRN);
 $("#rulerProducts li:nth-child(3)").html(sizeP);
 $("#rulerProducts li:nth-child(4)").html(sizeM);
 $("#rulerProducts li:nth-child(5)").html(sizeG);
 $("#rulerProducts li:nth-child(6)").html(sizeXG);
 $("#rulerProducts li:nth-child(7)").html(sizeXXG);
 $("#rulerProducts li:nth-child(8)").html(sizeDejar);
 }

 changeTextRule();*/


/*******************************************************************************
 Filtro lifstyle
 *******************************************************************************/

/*var products = {
 init: function() {
 if ($('.grid').length) {
 $('.grid').isotope({
 itemSelector: '.element-item'
 })

 this.binds()
 }
 },

 filter: function(selector) {
 if ($('.grid').length)
 $('.grid').isotope({
 filter: selector
 })
 },

 binds: function() {
 if ($('.filter-notas').length)
 $('.filter-notas .filter-item').on('click', function(e) {
 e.preventDefault()
 var selector = $(this).data('filter') || '*'
 products.filter(selector)
 $('.filter-notas .filter-item').removeClass('active')
 $(this).addClass('active')
 })
 }
 }

 $(function() {
 setTimeout(function() {
 products.init()
 }, 100);

 })*/


/*******************************************************************************
 Producto Unidades
 *******************************************************************************/

/*$(".tamanos .size").on("click", function(e) {
 var size = $(this).attr("data-size");
 $('.unid-size').removeClass("active");
 $('.unid-size' + size + '').addClass("active");
 $('.size').removeClass("active");
 $(this).addClass("active");
 e.preventDefault();
 });*/


/*******************************************************************************
 HERRAMIENTAS Ver Resultados
 *******************************************************************************/

/*$("#ver-resultado").on("click", function(e) {
  $('#resultado').addClass("active");
  e.preventDefault();
});*/

/*******************************************************************************
 MEDIABOX
 *******************************************************************************/

// MediaBox('.mediabox');


/*******************************************************************************
 STORES
 *******************************************************************************/

/*$(document).ready(function() {


  // Bind Pregnacy Calculate Btn
  $('.resultado').on('click', function(e) {
    e.preventDefault();
    validateValues();
  });

  // Bind Pregnacy Calculate Btn
  $('.fertility-result').on('click', function(e) {
    e.preventDefault();
    validateFertility();
  });

  //Bind Diaper Calculate Btn
  $('.diaper-result').on('click', function(e) {
    e.preventDefault();
    validateDiaper();
  });

  //Bind Names Explore Btn
  $('.display-names').on('click', function(e) {
    e.preventDefault();
    getNames();
  });

  // Gender Filter
  $('select.gender').on('change', function() {
    filterGender($(this).val());
  });

  // ABC Filter
  $('select.abc').on('change', function() {
    filterAbc($(this).val());
  });

  // Names Filter Paginator Btns
  $('.act-nombres .prev, .act-nombres .next').on('click', function(e) {
    e.preventDefault();
    changePage(filterNamesConfig.activePage, $(this).data('pagination'));
  })

  // Milk Tool
  $('.milk-result-btn').on('click', function(e) {
    e.preventDefault();
    scroll('.milk-result');
    $('.milk-result').addClass('active');

  })
});*/


// console.log("LANGUAGE: ", lang);

/*******************************************************************************
 Herramienta Embarazo
 *******************************************************************************/
/* var newDate,
   getWeeksDif,
   getMonthsDif;


 function validateValues() {
  var dateInput = $('input[name="_submit"]').val();
  var cycleDurationVal = $('.herramientas-hero .select-dropdown li.selected').text();
  var cycleDuration = parseInt(cycleDurationVal.substring(0, 2));
  var dateSelected = Date.parse(dateInput);

  if ((dateInput != '') && (!isNaN(cycleDuration))) {
    incrementDays(dateSelected, cycleDuration);
  }
 }

function incrementDays(date, cycleDuration) {
  var appendDays = 0;

  if (cycleDuration === 21) {
    appendDays = 273;
  }
  else if (cycleDuration > 21 && cycleDuration <= 40) {
    appendDays = (cycleDuration - 21) + 273;
  }
  var today = new Date();
  newDate = new Date(date);
  newDate.setDate(newDate.getDate()+(appendDays));

  // Set language
  options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  newDate = newDate.toLocaleDateString(navigator.language, options);

  getPregnacyTime(date, today);
}

function getPregnacyTime(date, today) {
  dt1 = new Date(date);
  dt2 = new Date(today);

  var getDaysDif = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /(1000 * 60 * 60 * 24));
  getWeeksDif = parseInt(getDaysDif / 7);
  getMonthsDif = parseFloat(getDaysDif / 30).toFixed(2);

  pregnacyResult();
}

function pregnacyResult() {
  $('#resultado .date').html(newDate + '.<span>¡Tienes ' + getWeeksDif + ' semanas de embarazo!</span>');

  scroll($('#resultado'));
  $('#resultado').addClass('active');
}*/

/*******************************************************************************
 Herramienta Fertilidad
 *******************************************************************************/
/* function validateFertility() {
  var dateInput = $('input[name="_submit"]').val();
  var cycleDurationVal = $('.herramientas-hero .select-dropdown li.selected').text();
  var cycleDuration = parseInt(cycleDurationVal.substring(0, 2));
  var dateSelected = Date.parse(dateInput);

  if ((dateInput != '') && (!isNaN(cycleDuration))) {
    calculateFertility(dateSelected, cycleDuration);
  }
 }

 function calculateFertility(date, cycleDuration) {
  var appendDays = 0;
  appendDays = cycleDuration / 2;

  startFertilityDay = new Date(date);
  startFertilityDay.setDate(startFertilityDay.getDate()+(appendDays));

  finishFertilityDay = new Date(date);
  finishFertilityDay.setDate(startFertilityDay.getDate()+(5));

  // Set date format
  options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  };

  startFertilityDay = startFertilityDay.toLocaleDateString(navigator.language, options);
  finishFertilityDay = finishFertilityDay.toLocaleDateString(navigator.language, options);

  // $('.fertility-result h1.title').text('Desde: ' + startFertilityDay + ' <br>Hasta: ' + finishFertilityDay);
  $('.fertility-result .fetility-start').text('Desde: ' + startFertilityDay);
  $('.fertility-result .fetility-finish').text('Hasta: ' + finishFertilityDay);

  scroll($('.fertility-result'));
  $('.fertility-result').addClass('active');
 }*/

/*******************************************************************************
Herramienta Pañales
*******************************************************************************/
/*function validateDiaper() {
  var weight = parseInt($('.diaper-input').val());
  var days = parseInt($('.days-input').val());
  if (weight != '' && days != 0) {
    calculateDiaper(weight, days);
  }
 }

 function calculateDiaper(weight, days) {
  var diaperResult;

  if (weight >= 0 && weight <=4) {
    diaperResult = days * 7;
  }
  else if (weight >= 5 && weight <= 9) {
    diaperResult = days * 6;
  }
  else if (weight >= 10 && weight <= 12) {
    diaperResult = days * 5;
  }
  // weight >= 13
  else {
    diaperResult = days * 3;
  }

  $('.diaper-result span').text(diaperResult);
  scroll('#resultado');
  $('#resultado').addClass('active');
}*/
/*******************************************************************************
Herramienta Nombres
*******************************************************************************/
/*var filterNamesConfig = {
  'gender': 'both',
  'letter': 'ALL',
  'lettersResults': 3,
  'activePage': 1,
  'totalLetters': 0,
  'totalPages': 0
};
var displayFiltered;

function getNames() {
  $.ajax({
    url: "../assets/extras/js/names.json",
    dataType: "json"
  }).done(function(data) {
    $('.result-nombres').empty();
    filterNamesConfig.totalLetters = Object.keys(data).length;
    $.each(data, function(letter, content) {
      var letterList = '<ul class="letter" data-letter="' + letter + '"><li class="letra">' + letter + '</li></ul>'
      $('.result-nombres').append(letterList);

      $.each(content, function(b, a) {
        $('.result-nombres ul[data-letter="' + letter + '"]').append('<li title="' + a.Referencia + '" data-gender="' + a.Genero + '">' + a.Nombre + '</li>');
      })
    })
    filterNamesConfig.activePage = 1;
    pagination();
  }).fail(function(jqXHR, textStatus, errorThrown) {
    console.log(textStatus + ': ' + errorThrown);
  });
}

function filterGender(elem) {
  filterNamesConfig.gender = elem;
  filterApply();
}

function filterAbc(elem) {
  var letter = elem.toUpperCase();
  filterNamesConfig.letter = letter;
  filterApply();
}

function filterApply() {
  $('.result-nombres ul').fadeOut(200, function() {
    if (filterNamesConfig.gender != 'both' && filterNamesConfig.letter != 'ALL') {
      $('.result-nombres ul li').hide();
      $('.result-nombres ul[data-letter="' + filterNamesConfig.letter + '"],  .result-nombres ul li[data-gender=' + filterNamesConfig.gender + ']').show();
      $('.result-nombres ul li.letra').show();
      $('.act-nombres').hide();
      displayNames();
    }
    else if (filterNamesConfig.letter !== 'ALL') {
      $('.result-nombres ul li').show();
      $('.result-nombres ul[data-letter="' + filterNamesConfig.letter + '"]').show();
      $('.act-nombres').hide();
      displayNames();
    }
    else if (filterNamesConfig.gender !== 'both') {
      $('.result-nombres ul li').hide();
      $('.result-nombres ul li[data-gender=' + filterNamesConfig.gender + '], .result-nombres ul li.letra, .result-nombres ul').show();
      pagination();
    }
    else {
      $('.result-nombres ul, .result-nombres ul li').show();
      pagination();
    }
  });
  filterNamesConfig.activePage = 1;
}

function changePage(activePage, action) {
  if (action === 'prev' && filterNamesConfig.activePage > 1) {
    filterNamesConfig.activePage = filterNamesConfig.activePage - 1;
  }
  if (action === 'next' && filterNamesConfig.activePage < filterNamesConfig.totalPages) {
    filterNamesConfig.activePage = filterNamesConfig.activePage + 1;
  }
  pagination();
}

function pagination() {
  if (filterNamesConfig.totalLetters > filterNamesConfig.lettersResults) {
    filterNamesConfig.totalPages = parseInt((filterNamesConfig.totalLetters / filterNamesConfig.lettersResults) + 1);
    $('.act-nombres').show();
    $('.result-nombres ul.letter').hide();

    var display1 = $('.result-nombres ul.letter')[filterNamesConfig.activePage * 3 - 3];
    var display2 = $('.result-nombres ul.letter')[filterNamesConfig.activePage * 3 - 2];
    var display3 = $('.result-nombres ul.letter')[filterNamesConfig.activePage * 3 - 1];
    $(display1).show();
    $(display2).show();
    $(display3).show();

  }
  displayNames();
}

function displayNames() {
  scroll('.succes-content');
  $('#resultado').addClass('active');
}*/

/*******************************************************************************
Scroll To Resultado
*******************************************************************************/
function scroll(elem) {
    var element = $(elem).offset().top;
    headerHeight = $('header').height();
    $('html, body').animate({
        scrollTop: element - headerHeight
    }, 400);
}




// FORMULARIO SALESFORCE
$(document).ready(function() {
    $('.documento').on('change', function() {
        // Obtener el valor seleccionado
        var selectedValue = $(this).val();
        console.log('Tipo de documento seleccionado:', selectedValue);

        // Cambiar dinámicamente el atributo maxlength del input según la opción seleccionada
        switch (selectedValue) {
            case 'DNI':
                $('.numero').attr('maxlength', 8);
                $('.numero').attr('minlength', 8);
                $('.numero').removeClass('disabled');
                $('.numero').addClass('enabled');
                break;
            case 'Carnet de Extranjería':
                $('.numero').attr('maxlength', 12);
                $('.numero').attr('minlength', 12);
                $('.numero').removeClass('disabled');
                $('.numero').addClass('enabled');
                break;
            case 'RUC':
                $('.numero').attr('maxlength', 11);
                $('.numero').attr('minlength', 11);
                $('.numero').removeClass('disabled');
                $('.numero').addClass('enabled');
                break;
            default:
                // Si no hay selección, restaurar el valor predeterminado
                $('.numero').attr('maxlength', 20);
                $('.numero').attr('minlength', 20);
                $('.numero').val(''); // Vaciar el campo
                $('.numero').removeClass('enabled');
                $('.numero').addClass('disabled');
        }

        // Quitar la propiedad 'required' si el valor seleccionado es vacío
        if (selectedValue === '') {
            $('.numero').prop('required', false);
        }
        else {
            // Establecer la propiedad 'required' si el valor seleccionado no es vacío
            $('.numero').prop('required', true);
        }
    });

    // Obtener el elemento con el ID 'phone'
    try {
        var phoneInput = document.getElementById('phone');

        phoneInput.addEventListener('input', function(event) {
            // Obtener el valor actual del campo de teléfono
            var phoneNumber = event.target.value;

            // Eliminar caracteres no numéricos usando una expresión regular
            phoneNumber = phoneNumber.replace(/[^\d]/g, '');

            // Actualizar el valor del campo de teléfono
            event.target.value = phoneNumber;
        });
    }
    catch (error) {
       // console.log("Ocurrió un error:", error.message);
    }
});